const DOM = {
  RVC_METHOD_NAME: '.rvc-method-name',
  RVC_METHOD_HELP: '.rvc-method-help',
};

module.exports = function () {
  $(DOM.RVC_METHOD_NAME).on('click', () => {
    var help = $(DOM.RVC_METHOD_HELP);

    if (help.is(':visible')) {
      help.hide();
    } else {
      help.show();
    }
  });
};
